import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames"
import {Tooltip} from "antd";

class ItemsTableRow extends Component {
    render() {
        const {item, index} = this.props
        const {status} = item

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending',
            'processing progress-bar-animated progress-bar-striped': status === 'processing',
            'failed': status === 'error',
            'cancelled': status === 'cancelled',
            'done': status === 'done',
        })

        return (
            <tr className="JobTableRow">
                <td>{index + 1}</td>
                <td>#{item.order.barcode_number}_{item.order.item_number}</td>
                <td className='StatusJob'>
                    {
                        item.status === 'error' ? (
                            <Tooltip title={item.error_message}>
                                <span className={`badge ${color} badge-pill`}>{item.status}</span>
                            </Tooltip>
                        ) : (
                            <span className={`badge ${color} badge-pill`}>{item.status}</span>
                        )
                    }
                </td>
            </tr>
        )
    }
}

ItemsTableRow.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired
}

export default ItemsTableRow